var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppImage',{attrs:{"alt":_vm.attrs.alt || null,"title":_vm.attrs.title || null,"crop":_vm.attrs.crop || null,"height":_vm.attrs.height || null,"src":_vm.src,"width":_vm.attrs.width || null,"image-class":_vm.imageClasses}})
}
var staticRenderFns = []

export { render, staticRenderFns }